<template>
  <b-modal id="modal-search"
          title="면적 선택"
          header-class="popup_header1"
           content-class="md_modal_content"
           :visible="visible"
           @hidden="onCancel();"
           @show="onShow"
           hide-footer centered>
      <div style="display: flex; flex-direction: column; align-self: center">
        <div class="align-vertical">
          <div class="align-horizontal paragraph_row paragraph_header">
            <div class="paragraph_title">분양면적</div>
            <div class="paragraph_title">전용면적</div>
            <div class="paragraph_title">전체 거래건수</div>
          </div>
          <!-- <InquiryItem5 v-for="item in list"
                    :item="item"
          /> -->
          <div class="align-horizontal paragraph_row paragraph_bottom_border">
            <div class="paragraph_content">86㎡</div>
            <div class="paragraph_content">전용 63.48㎡</div>
            <div class="paragraph_content">3</div>
          </div>
        </div>
      </div>
  </b-modal>
</template>

<script>

// import InquiryItem5 from "../InquiryItem5";

export default {
  name: "GraphPopup5",
  components: {
    // InquiryItem5,
  },
  props:["visible", "list"],
  data() {
    return {
      self: this,
    }
  },
  mounted() {
  },
  methods:{
    onShow() {
    },
    onCancel()  {
      this.$emit('update:visible', false);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/Modal.scss";

.paragraph_row {
  height: 40px;
}
.paragraph_header {
  background-color: $primary;
}
.paragraph_bottom_border {
  border-bottom: 1px solid $c_cacbcd;
}
.paragraph_title {
  flex:1;
  font-size: $fs_15;
  font-family: $korean_gd_13_r;
  color: $white;
  text-align: center;
}
.paragraph_content {
  flex:1;
  font-size: $fs_15;
  font-family: $korean_gd_14_r;
  color: $black;
  text-align: center;
}
.site_header{
  margin-bottom: 7px;
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}
.selected_info {
  border-radius: 5px;
  background-color: #e8f1fe;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  justify-content: space-between;
}
.center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.page_btn{
  @extend .center;
  width: 25px;
  height: 25px;
  color: #919191;
  font-size: $fs_18;
  font-family: $korean_gd_17_r;
  cursor: pointer;
}
.selected_title {
  color: #313131;
  font-size: $fs_14;
  font-family: $korean_gd_15_r;
}
.selected_content {
  color: $primary;
  font-size: $fs_18;
  font-family: $korean_gd_17_r;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/GraphPopup5.vue